<template>
  <!--右侧悬浮框-->
  <div class="rightFlex-main">
    <!--右侧悬浮框-->
    <div id="floorRight" class="floorRight">
      <ul class="floorRight-ul">
        <li @click="openCart">
          <div class="img img1">
            <Badge :count="cartCount" overflow-count="99" class="badge-icon">
              <a href="#" class="demo-badge"></a>
            </Badge>
          </div>
          <p class="floorRight-txt" @click="saveLine(5, '购物车')">购物车</p>
        </li>
        <li>
          <router-link to="/personal/PurchasePlan">
            <div class="img img6"></div>
            <p class="floorRight-txt" @click="saveLine(5, '采购计划')">采购计划</p>
          </router-link>
        </li>
        <li class="online-service">
          <div class="img img2"></div>
          <p class="floorRight-txt">在线客服</p>
        </li>
        <li>
          <router-link to="/personal/Favorites">
            <div class="img img3">
              <Badge :count="favoritesCount" overflow-count="99" class="badge-icon">
                <a href="#" class="demo-badge"></a>
              </Badge>
            </div>
            <p class="floorRight-txt"  @click="saveLine(5, '我的收藏')">我的收藏</p>
          </router-link>
        </li>
        <li>
          <router-link to="/personal/MyMessages">
            <div class="img img4">
              <Badge :count="messageCount" overflow-count="99" class="badge-icon">
                <a href="#" class="demo-badge"></a>
              </Badge>
            </div>
            <p class="floorRight-txt">我的消息</p>
          </router-link>
        </li>
        <li>
          <router-link to="/Personal/Rightpersonal">
            <div class="img img5"></div>
            <p class="floorRight-txt" @click="saveLine(5, '我的订单')">我的订单</p>
          </router-link>
        </li>
        <li>
          <router-link to="/personal/Purchase">
            <div class="img img6"></div>
            <p class="floorRight-txt">智能采购</p>
          </router-link>
        </li>
        <li>
          <router-link to="/Personal/UserFeedback">
            <div class="img img7"></div>
            <p class="floorRight-txt">客户反馈</p>
          </router-link>
        </li>
        <li>
          <router-link to="/personal/MyOrder?type=2">
            <div class="img img5"></div>
            <p class="floorRight-txt">待付款</p>
          </router-link>
        </li>
      </ul>
      <div class="call-num">
        <p class="call-img">
          <img src="static\img\index\img\分组 8.png" alt="" />
        </p>
        <p class="call-txt">全国热线电话</p>
        <p class="call-line"></p>
        <p class="call-phoneNum">0773-2669897</p>
        <!-- <span class="call-icon"></span>-->
      </div>
    </div>
    <!--右侧悬浮框-->
    <!--右侧购物车-->
    <template>
      <Drawer width="250" :closable="false" :mask="false" :scrollable="true" v-model="sideCart" class="cart-drawer">
        <div class="shopCart-container">
          <div class="title">
            <div class="shopCart-title">
              <img src="static/img/index/cart.png" alt="" />
              购物车
            </div>
            <div class="shopCart-title-delete" @click="close">
              <Icon type="ios-close" size="31" />
            </div>
          </div>
          <div class="shopCart-item">
            <ul v-if="cartList && cartList.length > 0">
              <li v-for="item in cartList" :key="item.cart_id">
                <div class="shopCart-activity" v-if="item.swap_msg &&
                  item.swap_msg.length > 0 &&
                  (item.cart_type.split(',').includes('2') ||
                    item.cart_type.split(',').includes('3'))
                  ">
                  <span class="shopCart-icon">
                    促销
                  </span>
                  <span v-for="(items, index) in item.swap_msg" :key="index"> {{ items }}</span>
                </div>
                <div class="shopCart-activity" v-if="(!item.swap_msg || item.ladder_msg.length <= 0) &&
                  item.ladder_msg &&
                  item.ladder_msg.length > 0
                  ">
                  <span class="shopCart-icon">阶梯价</span>
                  {{ item.ladder_msg }}
                </div>
                <div class="shopCart-details">
                  <div class="shopCart-details-img">
                    <img :src="item.goods_img ||
                      '../../../static/img/goodsList/goods_default_img.jpg'
                      " :onerror="defaultGoodsImg" alt="" />
                  </div>
                  <div class="shopCart-details-describe">
                    <a href="#" @click.prevent="toDetail(item)" class="shopCart-goods-intro">{{ item.goods_name }}</a>
                    <p class="shopCart-goods-spec">{{ item.specification }}</p>
                    <p class="shopCart-goods-price">
                      <span class="shopCart-newPrice">¥ {{ item.selling_price }}</span>
                      <span class="shopCart-goods-num">x{{ item.quantity }}</span>
                    </p>
                    <Icon class="shopCart-delete" type="ios-trash-outline" size="20" @click="delCart(item, 0)" />
                  </div>
                </div>
              </li>
            </ul>
            <p class="skill-tips" v-if="skillList && skillList.length > 0">
              秒杀购物车
            </p>
            <ul v-if="skillList && skillList.length > 0">
              <li v-for="item in skillList" :key="item.cart_id">
                <div class="shopCart-activity" v-if="item.swap_msg &&
                  item.swap_msg.length > 0 &&
                  (item.cart_type.split(',').includes('2') ||
                    item.cart_type.split(',').includes('3'))
                  ">
                  <span class="shopCart-icon">{{
                    item.cart_type.split(",").includes("2")
                    ? "买赠"
                    : item.cart_type.split(",").includes("3")
                      ? "换购"
                      : ""
                  }}</span>
                  {{ item.swap_msg }}
                </div>
                <div class="shopCart-activity" v-if="(!item.swap_msg || item.ladder_msg.length <= 0) &&
                  item.ladder_msg &&
                  item.ladder_msg.length > 0
                  ">
                  <span class="shopCart-icon">阶梯价</span>
                  {{ item.ladder_msg }}
                </div>
                <div class="shopCart-details">
                  <div class="shopCart-details-img">
                    <img :src="item.goods_img ||
                      '../../../static/img/goodsList/goods_default_img.jpg'
                      " :onerror="defaultGoodsImg" alt="" />
                  </div>
                  <div class="shopCart-details-describe">
                    <p class="shopCart-goods-intro">{{ item.goods_name }}</p>
                    <p class="shopCart-goods-spec">{{ item.specification }}</p>
                    <p class="shopCart-goods-price">
                      <span class="shopCart-newPrice">¥ {{ item.selling_price }}</span>
                      <span class="shopCart-goods-num">x{{ item.quantity }}</span>
                    </p>
                    <Icon class="shopCart-delete" type="ios-trash-outline" size="20" @click="delCart(item, 0)" />
                  </div>
                </div>
              </li>
            </ul>
            <div class="no-goodCart" v-if="cartList.length === 0 && skillList.length === 0">
              <p class="noCart-img">
                <img src="static/img/cart/no_cart.png" alt="" />
              </p>
              <p class="noCart-title">购物车</p>
              <p class="noCart-txt">您的购物车里什么也没有哦～</p>
            </div>
          </div>
          <div class="total" v-if="cartList.length > 0 || skillList.length > 0">
            <div class="total-item">
              <div class="goodsNum">
                <p class="goodsNum-price">
                  <span>总计：</span>
                  <span class="color-fa">¥ {{ sumPrice }}</span>
                </p>
                <p class="goodsNum-item">
                  已选商品
                  <span class="color-fa">{{
                    shoppingCart.general ? shoppingCart.general.length : 0
                  }}</span>件
                </p>
              </div>
              <div class="cart-btn">
                <router-link to="/ShopCart"> 去购物车结算 </router-link>
              </div>
            </div>
          </div>
        </div>
      </Drawer>
    </template>
    <!--右侧购物车-->
    <DeleteCart :dialog-visible.sync="delVisible" :delIds="delIds" :type="delType"></DeleteCart>
  </div>
</template>

<script>
import store from "@/vuex/store";
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
import $ from "jquery";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { getRightNumAndHotWords } from "@/api/commonApi";
import { deepClone, isEmpty, return2Float } from "@/utils";
import DeleteCart from "@/components/popup/DeleteCart";
import { lineLocal } from '@/api/apiPot.js'
export default {
  name: "RightFlex",
  components: {
    DeleteCart
  },
  data() {
    return {
      setIntervalObj: null,
      setIntervalWeekly: null,
      value2: 0,
      setting: {
        arrow: "never",
        autoplaySpeed: 3000
      },
      sideCart: false,
      defaultGoodsImg:
        'this.src="' +
        require("../../../static/img/goodsList/goods_default_img.jpg") +
        '"',
      cartCount: 0, //购物车角标数量
      favoritesCount: 0, //收藏角标数量
      messageCount: 0, //购信息角标数量
      cartList: [], //购物车
      skillList: [], //秒杀购物车
      delIds: "",
      delType: 1,
      delVisible: false,
      zoneGiftsList: [] //专区赠品列表
    };
  },
  computed: {
    // ...mapState(["userInfo", "asItems", "isLoading"]),
    ...mapGetters(["shoppingCart", "userName", "rightRefresh"]),

    //计算总价，选择被选中的元素
    sumPrice() {
      let carSum = 0,
        skillSum = 0,
        zoneGiftsSum = 0;
      if (this.zoneGiftsList && this.zoneGiftsList.length > 0) {
        this.zoneGiftsList.forEach(item => {
          zoneGiftsSum += parseFloat(item.subtotal)
        });
        console.log("赠品列表小计右侧", zoneGiftsSum)
      }
      if (this.cartList && this.cartList.length > 0) {
        carSum = this.cartList
          .filter(item => !this.isDisable(item) && item.selection === 1)
          .reduce((pre, cur) => {
            return (
              parseFloat(pre) +
              parseFloat(cur.subtotal) +
              (cur.gift ? parseFloat(cur.gift.subtotal) : 0)
            );
          }, 0);
      }

      if (this.skillList && this.skillList.length > 0) {
        skillSum = this.skillList
          .filter(item => !this.isDisable(item) && item.selection === 1)
          .reduce((pre, cur) => {
            return (
              parseFloat(pre) +
              parseFloat(cur.subtotal) +
              (cur.gift ? parseFloat(cur.gift.subtotal) : 0)
            );
          }, 0);
      }
      let sumP = parseFloat(carSum) + parseFloat(skillSum) + parseFloat(zoneGiftsSum) || 0;
      return return2Float(sumP);
      // return parseFloat(carSum) + parseFloat(skillSum);
    }
  },
  watch: {
    rightRefresh: {
      handler(newVal, oldVal) {
        this.rightNum();
      }
    },
    shoppingCart: {
      handler(newVal, oldVal) {
        this.zoneGiftsList = this.shoppingCart.show_goods_zp; //专区赠品列表
        this.rightNum();
        if (
          this.shoppingCart &&
          this.shoppingCart.general &&
          this.shoppingCart.general.length > 0
        ) {
          this.cartList = [];
          this.cartList = deepClone(this.shoppingCart.general);
        } else {
          this.cartList = [];
        }
        //秒杀购物车
        if (
          this.shoppingCart &&
          this.shoppingCart.skill &&
          this.shoppingCart.skill.length > 0
        ) {
          this.skillList = [];
          this.skillList = deepClone(this.shoppingCart.skill);
        } else {
          this.skillList = [];
        }
      },
      deep: true
      // immediate: true
    }
  },
  mounted() {
    /*右侧悬浮框效果*/
    $(".online-service").on({
      mouseover: function () {
        $(".call-num").show();
      },
      mouseout: function () {
        $(".call-num").hide();
      }
    });
    /*右侧悬浮框效果*/
    // 有token的情况下直接调购物车，没token直接获取角标  因为购物车调用时会自动刷新一遍角标
    if (!isEmpty(this.userName)) {
      // this.loadShoppingCart();
      this.rightNum();

    } else {
      this.rightNum();
    }
  },
  methods: {
    ...mapActions([
      "loadShoppingCart"
    ]),
    ...mapMutations(['new_customer_set']),
    saveLine(t, s) {
      lineLocal({ source_type: t, source_info: s })
    },
    openCart() {
      this.$router.push({
        path: '/ShopCart'
        /* query: { id: item.goods_id }*/
      });
      /*  if (this.sideCart == false) {
          $(".floorRight").css({ right: "250px" });
          this.sideCart = true;
        } else {
          this.sideCart = false;
          $(".floorRight").css({ right: "1%" });
        }*/
    },
    close() {
      this.sideCart = false;
      $(".floorRight").css({ right: "1%" });
    },
    rightNum() {
      /**右侧角标数量 */
      let _this = this;
      getRightNumAndHotWords()
        .then(res => {

          this.cartCount = res.data.cart_count;
          this.favoritesCount = res.data.favorites;
          this.messageCount = res.data.message_count;
          localStorage.setItem('new_customer', res.data.new_customer)
          this.new_customer_set(res.data.new_customer)
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 删除弹窗
    delCart(item, delType) {
      this.delIds = item.cart_id + "";
      this.delType = delType;
      this.delVisible = true;
    },
    deleteSingleCart(id) {
      console.log("删除来了");
      this.loadShoppingCart();
    },
    /**是否可选中 */
    isDisable(item) {
      // <!-- can_sale	int		是否销售，0否，1是 is_sale	int		是否上下架，0下架，1上架 -->

      return (
        parseInt(item.goods_number) <= 0 ||
        parseInt(item.can_sale) === 0 ||
        parseInt(item.is_sale) === 0
      );
    },
    // 新页面打开详情
    toDetail(item) {
      let routeUrl = this.$router.resolve({
        path: "/goodsDetail",
        query: { id: item.goods_id }
      });
      window.open(routeUrl.href, "_blank");
    }
  },
  store
};
</script>

<style lang="less" scoped>
.rightFlex-main {}

.floorRight {
  z-index: 10;
  position: fixed;
  right: 1%;
  top: 24.58%;
  width: 70px;
  background: #ffffff;
  box-shadow: 0px 4px 8px 0px rgba(196, 196, 196, 0.2);
  border-radius: 10px;
  border: 1px solid #f0f0f0;
  padding-bottom: 10px;

  .floorRight-ul {
    position: relative;

    .badge-icon {
      position: absolute;
      right: 0;
      top: 0;
    }

    .badge-icon /deep/ .ivu-badge-count {
      font-family: "Monospaced Number";
      line-height: 1;
      vertical-align: middle;
      position: absolute;
      transform: translateX(50%);
      top: -10px;
      right: 0;
      height: 16px;
      border-radius: 10px;
      min-width: 16px;
      background: #022A78;
      border: 1px solid transparent;
      color: #fff;
      line-height: 14px;
      text-align: center;
      padding: 0 0px;
      font-size: 12px;
      white-space: nowrap;
      transform-origin: -10% center;
      z-index: 10;
      box-shadow: 0 0 0 1px #fff;
    }

    li {
      margin-top: 10px;
      cursor: pointer;
      color: #666;

      a {
        color: #666;
      }
    }
  }

  .floorRight-ul li:hover .floorRight-txt {
    color: #022A78;
  }

  .call-num {
    position: absolute;
    top: 10%;
    right: 100%;
    width: 150px;
    height: 134px;
    background: #ffffff;
    box-shadow: 0px 2px 4px 0px rgba(216, 216, 216, 0.3);
    border-radius: 6px;
    border: 1px solid #f0f0f0;
    text-align: center;
    cursor: pointer;
    display: none;

    .call-icon {
      width: 0;
      height: 0;
      border-top: 10px solid transparent;
      border-left: 11px solid #fff;
      border-bottom: 10px solid transparent;
      position: absolute;
      top: 50px;
      right: -10px;
    }

    .call-img {
      width: 74px;
      height: 41px;
      margin: 14px auto auto auto;
    }

    .call-txt {
      font-size: 14px;
      font-family: PingFangHK-Medium, PingFangHK;
      font-weight: 500;
      color: #333333;
      line-height: 20px;
      padding-top: 10px;
      padding-bottom: 6px;
    }

    .call-line {
      width: 10px;
      /* height: 1px;*/
      border-top: 1px solid #e2e2e2;
      margin: 0 auto;
    }

    .call-phoneNum {
      font-size: 16px;
      font-family: PingFangHK-Medium, PingFangHK;
      font-weight: 500;
      color: #022A78;
      line-height: 22px;
      padding-top: 6px;
    }
  }

  .call-num::after {
    content: "";
    position: absolute;
    right: -6px;
    top: 50px;
    width: 0;
    height: 0px;
    border-style: solid;
    border-width: 7px;
    border-color: #fff #fff transparent transparent;
    transform: rotate(-316deg);
    box-shadow: 3px -3px 3px rgba(216, 216, 216, 0.3);
  }

  .img {
    width: 18px;
    height: 22px;
    margin: 0 auto;
    position: relative;
  }

  .img1 {
    background: url(/static/img/index/indexIcon.png) no-repeat -126px -51px;
  }

  .floorRight-ul li:hover .img1 {
    background: url(/static/img/index/indexIcon.png) no-repeat -90px -51px;
  }

  .img2 {
    background: url(/static/img/index/indexIcon.png) no-repeat -198px -51px;
  }

  .floorRight-ul li:hover .img2 {
    background: url(/static/img/index/indexIcon.png) no-repeat -162px -51px;
  }

  .img3 {
    background: url(/static/img/index/indexIcon.png) no-repeat -270px -51px;
  }

  .floorRight-ul li:hover .img3 {
    background: url(/static/img/index/indexIcon.png) no-repeat -234px -51px;
  }

  .img4 {
    background: url(/static/img/index/indexIcon.png) no-repeat -343px -51px;
  }

  .floorRight-ul li:hover .img4 {
    background: url(/static/img/index/indexIcon.png) no-repeat -307px -51px;
  }

  .img5 {
    background: url(/static/img/index/indexIcon.png) no-repeat -55px -85px;
  }

  .floorRight-ul li:hover .img5 {
    background: url(/static/img/index/indexIcon.png) no-repeat -19px -85px;
  }

  .img6 {
    background: url(/static/img/index/indexIcon.png) no-repeat -128px -85px;
  }

  .floorRight-ul li:hover .img6 {
    background: url(/static/img/index/indexIcon.png) no-repeat -92px -85px;
  }

  .img7 {
    background: url(/static/img/index/indexIcon.png) no-repeat -200px -85px;
  }

  .floorRight-ul li:hover .img7 {
    background: url(/static/img/index/indexIcon.png) no-repeat -164px -85px;
  }

  .floorRight-txt {
    font-size: 12px;
    font-family: PingFangHK-Regular, PingFangHK;
    font-weight: 400;
    color: #666;
    line-height: 17px;
    text-align: center;
  }
}

/*首页悬浮框*/
/*右侧固定购物车*/
/*  .scrollbar::-webkit-scrollbar {
        display: none; !* Chrome Safari *!
      }

      .scrollbar {
        scrollbar-width: none; !* firefox *!
        -ms-overflow-style: none; !* IE 10+ *!
        overflow-x: hidden;
        overflow-y: auto;
      }*/
.cart-drawer {
  z-index: 99999;
}

.cart-drawer /deep/ .ivu-drawer-content {
  background-color: #f8f8f8;
}

.cart-drawer /deep/ .ivu-drawer-close {
  top: 13px;
}

.cart-drawer /deep/ .ivu-drawer-body {
  padding: 0;
}

.cart-drawer /deep/ .ivu-drawer-body::-webkit-scrollbar {
  width: 5px;
}

.cart-drawer /deep/ .ivu-drawer-body::-webkit-scrollbar-thumb {
  width: 4px;
  height: 20px;
  background: #022A78;
  border-radius: 2px;
}

.cart-drawer /deep/ .ivu-drawer-body::-webkit-scrollbar-track {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 5px rgb(0 0 0 / 20%);
  background: rgba(0, 0, 0, 0.2);
}

.shopCart-container {
  .title {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    width: 250px;
    height: 50px;
    box-sizing: border-box;
    padding: 0 10px 0 16px;
    background-color: #f8f8f8;
    position: fixed;
    top: 0;
    z-index: 10;

    .shopCart-title {
      font-size: 18px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #333333;
      line-height: 25px;

      img {
        width: 20px;
        height: 20px;
      }
    }

    .shopCart-title-delete {
      color: #333333;
      cursor: pointer;
    }
  }

  .shopCart-item {
    margin: 50px 0 60px 0;
    background-color: #f8f8f8;

    ul li {
      box-sizing: border-box;
      padding: 0 10px;
      /*  display: -webkit-box;
              display: -ms-flexbox;
              display: flex;*/
      background-color: #fff;
      margin-bottom: 10px;
    }

    .shopCart-activity {
      font-size: 12px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #666;
      line-height: 19px;
      padding: 8px 0;
      border-bottom: 1px dashed #e2e2e2;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      .shopCart-icon {
        background: #ff9606;
        border-radius: 2px;
        font-size: 12px;
        font-family: PingFangHK-Regular, PingFangHK;
        font-weight: 400;
        color: #ffffff;
        line-height: 17px;
        text-align: center;
        padding: 2px 5px;
      }
    }

    .shopCart-details {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      padding: 14px 0 10px 0;
      width: 230px;
      cursor: pointer;

      .shopCart-details-img {
        width: 80px;
        height: 80px;
        margin-right: 8px;

        img {
          width: 80px;
          height: 80px;
        }
      }

      .shopCart-details-describe {
        padding-top: 3px;
        width: 100%;
        position: relative;

        .shopCart-goods-intro {
          font-size: 12px;
          font-family: PingFangHK-Regular, PingFangHK;
          font-weight: 400;
          color: #333333;
          line-height: 17px;
          cursor: pointer;
        }

        .shopCart-goods-spec {
          font-size: 12px;
          font-family: PingFangHK-Regular, PingFangHK;
          font-weight: 400;
          color: #a2a2a2;
          padding-top: 18px;
        }

        .shopCart-goods-price {
          font-size: 12px;
          font-family: PingFangHK-Regular, PingFangHK;
          color: #022A78;
          padding-top: 5px;

          .shopCart-goods-num {
            color: #666;
          }
        }

        .shopCart-delete {
          position: absolute;
          right: 0;
          bottom: 1px;
          display: none;
        }
      }
    }

    .shopCart-details:hover .shopCart-delete {
      display: block;
    }

    .no-goodCart {
      margin-top: 260px;
      text-align: center;

      .noCart-img {
        width: 210px;
        height: 105px;
        margin: 0 auto;
      }

      .noCart-title {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        padding-top: 20px;
      }

      .noCart-txt {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666;
        padding-top: 6px;
      }
    }
  }

  .total {
    position: fixed;
    bottom: 0;
    z-index: 10;
    box-sizing: border-box;
    padding: 10px;
    background-color: #f8f8f8;
    width: 250px;

    .total-item {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      justify-content: space-between;

      .goodsNum {
        font-family: PingFangHK-Regular, PingFangHK;

        .goodsNum-price {
          font-size: 12px;
          color: #333333;
        }

        .color-fa {
          color: #022A78;
        }

        .goodsNum-item {
          font-size: 12px;
          color: #666;
        }
      }

      .cart-btn {
        width: 110px;
        height: 40px;
        background: #022A78;
        box-shadow: 0px 2px 6px 0px rgba(2, 42, 120, 0.2);
        text-align: center;
        line-height: 40px;

        a {
          color: #fff;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
        }
      }
    }
  }
}

/*右侧固定购物车*/
// 购物车-秒杀文字
.skill-tips {
  font-size: 16px;
  font-weight: 700;
  margin-top: 20px;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/nav/RightFlex.vue